import { TenantConfiguration, PactTenantConfiguration } from '../configure'

import oidc from './oidc'
import { Manager } from './types'

const createEmptyManager = (): Manager => {
	const notInitialized: any = () => {
		throw 'The UserManger is not yet initialized'
	}

	return {
		getAuthHeader: notInitialized,
		signin: notInitialized,
		signout: notInitialized,
		signinCallback: notInitialized,
		signoutCallback: notInitialized,
		keepAlive: notInitialized,
		signinPopup: notInitialized,
		addEventListener: notInitialized,
	}
}

const isPactConfiguration = (obj: any): obj is PactTenantConfiguration => {
	return !!obj.pact
}

// TODO: change configuration type here
const createManager = (config: TenantConfiguration | PactTenantConfiguration, anonymous?: boolean) => {
	// Support for PACT tests which are still using ROLE auth (to set up http headers).
	if (isPactConfiguration(config)) {
		const mgr = createEmptyManager()

		mgr.getAuthHeader = () =>
			Promise.resolve((config as any).role === null ? undefined : `Role ${config.pact.role}`)

		return mgr
	}

	return oidc(config, anonymous)
}

const manager = createEmptyManager()

const initialize = (config: TenantConfiguration | PactTenantConfiguration, anonymous?: boolean) => {
	let instance: object

	const authMode = resolveAuthMode()
	if (authMode !== 'ULS_AUTH') {
		instance = authMode
	} else {
		instance = createManager(config, anonymous)
	}

	const obj = manager as any

	Object.keys(obj).forEach((key) => {
		obj[key] = (instance as any)[key]
	})

	return manager
}

const resolveAuthMode = () => {
	// Make sure that in default production deployment, we use the standard auth method(s)
	//
	// IMPORTANT:
	// Do not change this next line, unless you update the NGINX internal_auth.conf template in /deploy/nginx/etc/nginx/templates/internal_auth.conf as well!!
	// (it is used as a marker to dynamically change the javascript in certain cases)
	return 'ULS_AUTH'.trim() as any
}

export { initialize }

// Singleton implementation - dont like this :(
export default manager
